import { render, staticRenderFns } from "./a-propos.vue?vue&type=template&id=02755ec8&"
import script from "./a-propos.vue?vue&type=script&lang=js&"
export * from "./a-propos.vue?vue&type=script&lang=js&"
import style0 from "./a-propos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules_dev/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports